/**
 * Secure logging utility
 * Only logs in development environment to prevent sensitive data exposure
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: unknown[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  error: (...args: unknown[]) => {
    if (isDevelopment) {
      console.error(...args);
    }
    // In production, you could send to error tracking service like Sentry
    // Example: Sentry.captureException(args[0]);
  },

  warn: (...args: unknown[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  info: (...args: unknown[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  debug: (...args: unknown[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
};

// Helper to replace direct console usage throughout the app
// Usage: import { disableConsoleLogs } from '@/lib/logger';
export const disableConsoleLogs = () => {
  if (!isDevelopment) {
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
    console.warn = () => {};
    // Keep console.error for critical errors
  }
};

/**
 * Sanitize error for safe logging (remove sensitive details)
 */
export function sanitizeError(error: unknown): {
  message: string;
  type: string;
} {
  if (error instanceof Error) {
    return {
      message: error.message,
      type: error.name,
    };
  }
  return {
    message: 'Unknown error occurred',
    type: 'UnknownError',
  };
}
